import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    isLogin_: false,
    token: "",
    user: {},
  },
};

export const imperialAuthSlice = createSlice({
  name: "imperial",
  initialState: initialState,
  reducers: {
    setIsLogin_(state, action) {
      state.data.isLogin_ = action.payload
    },
    setToken(state, action) {
      state.data.token = action.payload
    }
  },
});

export const { setIsLogin_, setToken } = imperialAuthSlice.actions;

export default imperialAuthSlice.reducer;
